module.exports = __webpack_public_path__ + "static/media/ERPL.59b53203.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/ERPL.jpg
// module id = 1739
// module chunks = 1